import React from 'react'

function About() {
    return (
        <section className="py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="text-center">
                            <h2 className="display-5 fw-bold">About Us</h2>
                            <p className="lead">
                                Welcome to <strong>Resume Maker</strong>! We are passionate about helping job seekers
                                create professional, eye-catching resumes that highlight their skills and experience.
                                Our platform is designed to be intuitive, fast, and user-friendly, allowing you to
                                focus on what matters most—landing your dream job.
                            </p>
                            <p className="lead">
                                Whether you’re a fresh graduate or a seasoned professional, our tools help you
                                present your qualifications in the best possible way. We believe that a great resume
                                is the first step to a successful career, and we’re here to make that step effortless.
                            </p>


                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About
